import { LOGIN_PATH_REGEX } from './redirectTarget'
import { resolveSectionFromLocation } from './sectionRouting'

const PUBLIC_ADMIN_PATH_REGEX = /^(?:\/login|\/forgot-password|\/reset-password)\/?$/

export const isAdminPath = (pathname: string): boolean => {
  return Boolean(resolveSectionFromLocation('', '', pathname)) || isPublicAdminPath(pathname)
}

export const isPublicAdminPath = (pathname: string): boolean =>
  LOGIN_PATH_REGEX.test(pathname) || PUBLIC_ADMIN_PATH_REGEX.test(pathname)

export const isProtectedAdminPath = (pathname: string): boolean =>
  isAdminPath(pathname) && !isPublicAdminPath(pathname)
